module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9688.7e83cf61.jpg";